import React, { useCallback, useEffect, useState } from "react";
import "./admin.css";

const API = process.env.REACT_APP_BACKEND_URL;

const LABELS = {
  crewStrike: "שביתת מלחים",
  closedShipyard: "מספנה סגורה",
  closedPorts: 'נמלים סגורים (ערפל)',
  navError: "טעויות ניווט (רוחות)",
  fixedGuardPrice: "מחיר ספינות משמר קבוע",
  bankInterest: "ריבית בנק 10%",
};

export default function ModeConfigAdmin() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  const fetchConfig = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API}/api/admin/mode-config`, { credentials: "include" });
      if (!res.ok) throw new Error(`status ${res.status}`);
      const data = await res.json();
      setConfig(data.defaults || {});
    } catch (e) {
      console.warn("failed to load mode config", e);
      setError("שגיאה בטעינת הגדרות המצב");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  const toggle = (key) => {
    setSaved(false);
    setConfig((c) => ({ ...c, [key]: !c[key] }));
  };

  const save = async () => {
    setSaved(false);
    setError("");
    try {
      const res = await fetch(`${API}/api/admin/mode-config`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ defaults: config }),
      });
      if (!res.ok) throw new Error(`status ${res.status}`);
      const data = await res.json();
      setConfig(data.defaults);
      setSaved(true);
    } catch (e) {
      console.warn("failed to save", e);
      setError("שמירה נכשלה");
    }
  };

  if (loading || !config) {
    return <div className="admin-empty" data-testid="mode-loading">...טוען</div>;
  }

  return (
    <div className="mode-config" data-testid="mode-config">
      <div className="admin-toolbar">
        <div className="admin-sub">הגדרות מצב משחק "מקורי"</div>
      </div>
      <div className="mode-config-help">
        קבעו את הערכים המייצגים את המשחק המקורי. שיא שהושג עם הגדרות
        זהות לערכים אלו יסומן כ-<b>"משחק מקורי"</b>. כל שינוי
        מהערכים האלו - השיא יישמר כ-<b>"משחק עם הקלות"</b>.
      </div>
      {error && <div className="admin-error" data-testid="mode-error">{error}</div>}
      <div className="mode-config-list">
        {Object.entries(config).map(([key, val]) => (
          <div className="mode-config-row" key={key} data-testid={`mode-row-${key}`}>
            <div className="mode-config-label">{LABELS[key] || key}</div>
            <button
              className={"mode-toggle" + (val ? " on" : "")}
              data-testid={`mode-toggle-${key}`}
              onClick={() => toggle(key)}
              type="button"
            >
              <span className="mode-toggle-thumb" />
              <span className="mode-toggle-text">{val ? "דלוק" : "כבוי"}</span>
            </button>
          </div>
        ))}
      </div>
      <div className="mode-config-actions">
        <button className="rbtn" data-testid="mode-save-btn" onClick={save}>
          שמור הגדרות מצב
        </button>
        {saved && <span className="mode-saved" data-testid="mode-saved">✓ נשמר</span>}
      </div>
    </div>
  );
}
